'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var index$1 = require('../../../../../../../node_modules/@fortawesome/pro-solid-svg-icons/index.cjs');
var React = require('react');
var IconButton_web = require('../../../atoms/IconButton/IconButton.web.cjs');
var Pill_web = require('../../../atoms/Pill/Pill.web.cjs');
var DropdownMenu_web = require('../../../molecules/DropdownMenu/DropdownMenu.web.cjs');
var PillGroup_web = require('../../../molecules/PillGroup/PillGroup.web.cjs');
var PreferredPill_web = require('../../PreferredPill/PreferredPill.web.cjs');
var QualityBadge_web = require('../../QualityBadge/QualityBadge.web.cjs');
var TopBar_web_styles = require('./TopBar.web.styles.cjs');

/**
 * Description added in ProductCard.web.tsx
 */ const TopBar = ({ qualityBadge, isPreferred = false, isTested = false, isFavorited = false, onFavoriteClick, isFavoriteDisabled = false, pills, isLoading = false, children })=>{
    const [isOpen, setIsOpen] = React.useState(false);
    const hasFavoriteButton = !!onFavoriteClick || isFavorited;
    if (isLoading) {
        return /*#__PURE__*/ jsxRuntime.jsx("div", {
            css: TopBar_web_styles.topBar
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: TopBar_web_styles.topBar,
        children: [
            /*#__PURE__*/ jsxRuntime.jsxs("span", {
                css: [
                    TopBar_web_styles.actions.base,
                    TopBar_web_styles.actions.left
                ],
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx(QualityBadge_web.QualityBadge, {
                        type: qualityBadge
                    }),
                    isPreferred && /*#__PURE__*/ jsxRuntime.jsx(PreferredPill_web.PreferredPill, {
                        size: "small"
                    }),
                    isTested && /*#__PURE__*/ jsxRuntime.jsx(Pill_web.Pill, {
                        size: "small",
                        backgroundColor: "sand",
                        labelContent: "Tested",
                        tooltipContent: "Third party tested"
                    }),
                    pills && /*#__PURE__*/ jsxRuntime.jsx(PillGroup_web.PillGroup, {
                        size: "small",
                        pills: pills,
                        truncateAfter: 1
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("span", {
                css: TopBar_web_styles.actions.base,
                children: [
                    children && /*#__PURE__*/ jsxRuntime.jsxs(DropdownMenu_web.DropdownMenu, {
                        isOpen: isOpen,
                        onOpenChange: ()=>setIsOpen(!isOpen),
                        children: [
                            /*#__PURE__*/ jsxRuntime.jsx(DropdownMenu_web.DropdownMenu.Trigger, {
                                children: /*#__PURE__*/ jsxRuntime.jsx(IconButton_web.IconButton, {
                                    variant: "tertiary",
                                    size: "small",
                                    customCss: [
                                        isOpen && TopBar_web_styles.kebabTrigger.open,
                                        TopBar_web_styles.mobileVisible
                                    ],
                                    className: isOpen ? "" : "visible-on-card-hover",
                                    "aria-label": "More options.",
                                    icon: index.faEllipsisV
                                })
                            }),
                            /*#__PURE__*/ jsxRuntime.jsx(DropdownMenu_web.DropdownMenu.Content, {
                                align: "end",
                                customDropdownWidth: 250,
                                children: children
                            })
                        ]
                    }),
                    hasFavoriteButton && !isLoading && /*#__PURE__*/ jsxRuntime.jsx(IconButton_web.IconButton, {
                        variant: "tertiary",
                        size: "small",
                        onClick: onFavoriteClick,
                        disabled: isFavoriteDisabled,
                        className: isFavorited ? "" : "visible-on-card-hover",
                        customCss: TopBar_web_styles.mobileVisible,
                        "aria-label": isFavorited ? "Remove from favorites." : "Add to favorites.",
                        icon: isFavorited ? index$1.faStar : index.faStar
                    })
                ]
            })
        ]
    });
};

exports.TopBar = TopBar;
//# sourceMappingURL=TopBar.web.cjs.map
